import * as types from "./../action-types";
import axios from "axios";
import { isEmpty, get, compact, sortBy } from "lodash";

const fetchRetailers = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("v2/retailers.json")
      .then((response) => {
        commit(types.FETCH_RETAILERS.SUCCESS, response.data);
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_RETAILERS.ERROR, error);
        reject(error);
      });
  });
};
async function fetchMasterData({ commit }) {
  let requests = [
    axios
      .get("v2/reasons.json", { params: { active: true } })
      .catch((err) => null),
    axios.get("v2/products.json").catch((err) => null),
    axios.get("v2/markets.json").catch((err) => null),
    axios.get("v3/permissions/roles", {}).catch((err) => null),
  ];
  let responses = compact(await axios.all(requests));
  let results = responses.map((resp) => get(resp, "data", null));
  commit(types.FETCH_REASONS.SUCCESS, results[0]);
  commit(types.FETCH_PRODUCTS.SUCCESS, results[1]);
  commit(types.FETCH_MARKETS.SUCCESS, results[2]);
  commit(types.FETCH_ROLES.SUCCESS, results[3]);
  try {
  } catch (e) {
    console.error(e);
    throw e.response;
  }
}

const fetchReasons = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("v2/reasons.json", { params: { active: true } })
      .then((response) => {
        commit(types.FETCH_REASONS.SUCCESS, response.data);
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_REASONS.ERROR, error);
        reject(error);
      });
  });
};

const fetchPermissions = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("v3/permissions", {})
      .then((response) => {
        commit(types.FETCH_PERMISSIONS.SUCCESS, response.data);
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_PERMISSIONS.ERROR, error);
        reject(error);
      });
  });
};

const fetchFeatureFlags = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("admin_configurations/flags.json", {})
      .then((response) => {
        commit(types.FETCH_FEATURE_FLAGS.SUCCESS, response.data);
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_FEATURE_FLAGS.ERROR, error);
        reject(error);
      });
  });
};

const fetchProducts = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("v2/products.json")
      .then((response) => {
        let products = sortBy(response.data, ["description"]);
        commit(types.FETCH_PRODUCTS.SUCCESS, products);
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_PRODUCTS.ERROR, error);
        reject(error);
      });
  });
};

const addProfile = ({ commit }, { params }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        "v2/device_profiles.json",
        { device_profile: params },
        { headers: { "X-CUSTOMER-AUTH": 0 } }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const addRegisterActivity = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    axios
      .post("v2/register_activity", params)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const fetchCountries = ({ commit, getters }) => {
  let alreadyLoaded = !isEmpty(getters.countries);
  if (alreadyLoaded) {
    return new Promise((resolve, _) => resolve(true));
  }
  return new Promise((resolve, reject) => {
    axios
      .get("/v2/countries.json")
      .then((response) => {
        commit(types.FETCH_COUNTRIES.SUCCESS, response.data);
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_COUNTRIES.ERROR, error);
        reject(error);
      });
  });
};

const fetchCountryStates = ({ commit, getters }, countryCode) => {
  countryCode = countryCode || "US"; //default
  let countries = getters.countries[countryCode];
  let alreadyLoaded = !isEmpty(get(countries, "states", {}));
  if (alreadyLoaded) {
    return new Promise((resolve, _) => resolve(true));
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`/v2/countries/${countryCode}/states.json`)
      .then((response) => {
        commit(types.FETCH_COUNTRY_STATES.SUCCESS, {
          data: response.data,
          countryCode,
        });
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_COUNTRY_STATES.ERROR, error);
        reject(error);
      });
  });
};

const fetchPIIAuthorizationStatus = ({ rootGetters }) => {
  return axios.get(
    `v2/customers/${rootGetters["db/account/customerId"]}/pii_authorization_status`
  );
};

export default {
  fetchCountries,
  fetchCountryStates,
  fetchReasons,
  fetchProducts,
  fetchMasterData,
  fetchRetailers,
  addRegisterActivity,
  addProfile,
  fetchPermissions,
  fetchFeatureFlags,
  fetchPIIAuthorizationStatus,
};
